import twColors from '../constants/colors'
import { CanvasElementType } from '../constants/common'
import HLine from './horizontal_line'
import { IScaledLineAttrs } from './scaled_line'

class PriceAlertLine<Attrs extends IScaledLineAttrs = IScaledLineAttrs> extends HLine<Attrs> {
  static type = CanvasElementType.priceAlertLine

  getIsInChartView() {
    // This is them solution in case of reverting deployed https://github.com/finvizhq/Finviz-Website/pull/3475
    return false
  }

  getDefaults() {
    return {
      border: {
        width: 1,
        color: twColors.gray[400],
      },
    } as Partial<Attrs>
  }
}

export default PriceAlertLine
